

import React, { useState, useEffect, useRef } from "react";
import { db } from "../firebaseConfig";
import { collection, addDoc, getDocs, doc, deleteDoc, updateDoc } from "firebase/firestore";
import SignatureCanvas from "react-signature-canvas";
import {
  Avatar,
  Container,
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography,
  Paper,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
  IconButton,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Alert,
  useTheme,
  Grid
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";

const RegistroContacto = () => {
  const [contactos, setContactos] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [roles, setRoles] = useState([]);
  const [formVisible, setFormVisible] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [currentContactId, setCurrentContactId] = useState(null);
  //const [actualizarFirma, setActualizarFirma] = useState(false);
  const initialFormData = {
    nombre: "",
    apellido: "",
    correo: "",
    telefono: "",
    id_empresa: "",
    id_rol: "",
    firma: "",
    avatar: "",
  };
  // const [formData, setFormData] = useState({
  //   nombre: "",
  //   apellido: "",
  //   correo: "",
  //   telefono: "",
  //   id_empresa: "",
  //   id_rol: "",
  //   firma: "",
  //   avatar: "",
  // });
  const [formData, setFormData] = useState(initialFormData);


  const [openDeleteDialog, setOpenDeleteDialog] = useState(false); // Estado para abrir/ cerrar el modal de eliminación
  const [alertMessage, setAlertMessage] = useState(""); // Mensaje de alerta
  const [alertOpen, setAlertOpen] = useState(false); // Estado para abrir/ cerrar la alerta
  const [alertSeverity, setAlertSeverity] = useState("success"); // Severidad de la alerta (success, error)

  const signatureRef = useRef(null);
  //const isMobile = useMediaQuery("(max-width: 600px)");
  const isMobile = useMediaQuery(useTheme().breakpoints.down("sm"));

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData({ ...formData, avatar: reader.result });
      };
      reader.readAsDataURL(file);
    }
  };

  const [selectedContact, setSelectedContact] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);


  // Función para cerrar el modal
  const handleCloseDialog = () => {
    setOpenDialog(false); // Cerrar el modal
  };

  const handleViewContact = (contacto) => {
    setSelectedContact(contacto);
    setOpenDialog(true); // Abrir el modal
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const empresasSnapshot = await getDocs(collection(db, "empresas"));
        const rolesSnapshot = await getDocs(collection(db, "rol"));
        const contactosSnapshot = await getDocs(collection(db, "contactos"));

        setEmpresas(empresasSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
        setRoles(rolesSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
        setContactos(contactosSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      } catch (error) {
        console.error("Error al obtener datos:", error);
      }
    };

    fetchData();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSaveSignature = () => {
    if (signatureRef.current && !signatureRef.current.isEmpty()) {
      setFormData({ ...formData, firma: signatureRef.current.toDataURL("image/png") });
    } else {
      alert("Por favor firme antes de guardar.");
    }
  };

  const handleClearSignature = () => {
    if (signatureRef.current) {
      signatureRef.current.clear();
      setFormData({ ...formData, firma: "" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editMode) {
        // Actualiza el contacto
        const contactRef = doc(db, "contactos", currentContactId);
        await updateDoc(contactRef, formData);
        setContactos(contactos.map(contacto => contacto.id === currentContactId ? { id: currentContactId, ...formData } : contacto)); // Actualiza la lista de contactos
        setAlertMessage("Contacto actualizado exitosamente.");
        setAlertSeverity("success");
      } else {
        // Si es un nuevo contacto
        const newContactRef = await addDoc(collection(db, "contactos"), formData);
        setContactos([...contactos, { id: newContactRef.id, ...formData }]); // Añade el nuevo contacto a la lista
        setAlertMessage("Nuevo contacto agregado exitosamente.");
        setAlertSeverity("success");
      }
      setFormData({
        nombre: "",
        apellido: "",
        correo: "",
        telefono: "",
        id_empresa: "",
        id_rol: "",
        firma: "",
        avatar: "",
      });
      signatureRef.current.clear();
      setFormVisible(false);
      setEditMode(false);
      setCurrentContactId(null);
      setAlertOpen(true); // Mostrar la alerta
    } catch (error) {
      console.error("Error al agregar o actualizar contacto:", error);
      setAlertMessage("Ocurrió un error. Intenta nuevamente.");
      setAlertSeverity("error");
      setAlertOpen(true); // Mostrar la alerta
    }
  };

  const handleDelete = async (contactId) => {
    try {
      const contactRef = doc(db, "contactos", contactId);
      await deleteDoc(contactRef);
      setContactos(contactos.filter((contacto) => contacto.id !== contactId)); // Elimina el contacto de la lista local
      setAlertMessage("Contacto eliminado exitosamente.");
      setAlertSeverity("success");
      setAlertOpen(true); // Mostrar la alerta
    } catch (error) {
      console.error("Error al eliminar contacto:", error);
      setAlertMessage("Ocurrió un error al eliminar el contacto.");
      setAlertSeverity("error");
      setAlertOpen(true); // Mostrar la alerta
    }
    setOpenDeleteDialog(false); // Cerrar el modal
  };

  const handleEdit = (contacto) => {
    setFormVisible(true);
    setEditMode(true);
    setCurrentContactId(contacto.id);
    setFormData({
      nombre: contacto.nombre,
      apellido: contacto.apellido,
      correo: contacto.correo,
      telefono: contacto.telefono,
      id_empresa: contacto.id_empresa,
      id_rol: contacto.id_rol,
      firma: contacto.firma,
      avatar: contacto.avatar || "",
    });
  };

  const handleOpenDeleteDialog = (contactId) => {
    setCurrentContactId(contactId);
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
  };

  return (
    <Container maxWidth="lg" sx={{ paddingBottom: 2 }}>
      {!formVisible ? (
        <>
          <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1A3E5D", marginBottom: 2 }}>
            Lista de Contactos
          </Typography>

          <Button
            variant="contained"
            color="primary"
            startIcon={<AddCircleIcon />}
            onClick={() => setFormVisible(true)}
            sx={{ marginBottom: 2 }}
          >
            Nuevo Contacto
          </Button>

          {isMobile ? (
            <Box>
              {contactos.map((contacto) => (
                <Card key={contacto.id} sx={{ marginBottom: 2, padding: 2 }}>
                  <CardContent>
                    {contacto.avatar && <Avatar src={contacto.avatar} sx={{ width: 50, height: 50 }} />}
                    <Typography><b>Nombre:</b> {`${contacto.nombre} ${contacto.apellido}`}</Typography>
                    {/* <Typography><b>Correo:</b> {contacto.correo}</Typography>
                    <Typography><b>Teléfono:</b> {contacto.telefono}</Typography> */}
                    <Typography><b>Empresa:</b> {empresas.find((empresa) => empresa.id === contacto.id_empresa)?.nombre}</Typography>
                    <Typography><b>Rol:</b> {roles.find((rol) => rol.id === contacto.id_rol)?.nombre}</Typography>
                    {/* {contacto.firma && <img src={contacto.firma} alt="Firma" style={{ width: "100%", maxWidth: "150px", marginTop: 10 }} />} */}
                    <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: 1 }}>
                      <IconButton color="primary" onClick={() => handleViewContact(contacto)}>
                        <VisibilityIcon />
                      </IconButton>
                      <IconButton color="primary" onClick={() => handleEdit(contacto)}>
                        <EditIcon />
                      </IconButton>
                      <IconButton color="secondary" onClick={() => handleOpenDeleteDialog(contacto.id)}>
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  </CardContent>
                </Card>
              ))}
            </Box>
          ) : (
            <TableContainer component={Paper} sx={{ marginTop: 2, }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Avatar</TableCell>
                    <TableCell>Nombre</TableCell>
                    {/* <TableCell>Correo</TableCell>
                    <TableCell>Teléfono</TableCell> */}
                    <TableCell>Empresa</TableCell>
                    <TableCell>Rol</TableCell>
                    {/* <TableCell>Firma</TableCell> */}
                    <TableCell>Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {contactos.map((contacto) => (
                    <TableRow key={contacto.id}>
                      <TableCell>
                        {contacto.avatar && <Avatar src={contacto.avatar} sx={{ width: 50, height: 50 }} />}
                      </TableCell>
                      <TableCell>{`${contacto.nombre} ${contacto.apellido}`}</TableCell>
                      {/* <TableCell>{contacto.correo}</TableCell>
                      <TableCell>{contacto.telefono}</TableCell> */}
                      <TableCell>{empresas.find((empresa) => empresa.id === contacto.id_empresa)?.nombre}</TableCell>
                      <TableCell>{roles.find((rol) => rol.id === contacto.id_rol)?.nombre}</TableCell>
                      {/* <TableCell>
                        {contacto.firma && <img src={contacto.firma} alt="Firma" style={{ width: "100px", height: "50px" }} />}
                      </TableCell> */}
                      <TableCell>
                        <IconButton color="primary" onClick={() => handleViewContact(contacto)}>
                          <VisibilityIcon />
                        </IconButton>
                        <IconButton color="primary" onClick={() => handleEdit(contacto)}>
                          <EditIcon />
                        </IconButton>
                        <IconButton color="secondary" onClick={() => handleOpenDeleteDialog(contacto.id)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </>
      ) : (
        <Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 2 }}>
            <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1A3E5D" }}>
              {editMode ? "Editar Contacto" : "Nuevo Contacto"}
            </Typography>
            {/* <IconButton onClick={() => setFormVisible(false)} color="#01579b" >
              <CloseIcon />
            </IconButton> */}
            <IconButton
              onClick={() => {
                setFormData(initialFormData);
                signatureRef.current.clear();
                setFormVisible(false);
                setEditMode(false);
                setCurrentContactId(null);
              }}
              color="#01579b"
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <form onSubmit={handleSubmit}>
            <Box sx={{ marginBottom: 2 }}>
              <Typography variant="h6" sx={{ marginTop: 2 }}>
                Subir Avatar (Foto)
              </Typography>
              <input type="file" accept="image/*" onChange={handleAvatarChange} />
              {formData.avatar && <img src={formData.avatar} alt="Avatar" style={{ width: "100px", height: "100px", marginTop: "10px" }} />}
            </Box>
            <TextField label="Nombre" name="nombre" value={formData.nombre} onChange={handleChange} fullWidth required margin="normal" />
            <TextField label="Apellido" name="apellido" value={formData.apellido} onChange={handleChange} fullWidth required margin="normal" />
            <TextField label="Correo" name="correo" value={formData.correo} onChange={handleChange} fullWidth required margin="normal" />
            <TextField label="Teléfono" name="telefono" value={formData.telefono} onChange={handleChange} fullWidth required margin="normal" />

            <FormControl fullWidth required margin="normal">
              <InputLabel>Empresa</InputLabel>
              <Select name="id_empresa" value={formData.id_empresa} onChange={handleChange}>
                {empresas.map((empresa) => (
                  <MenuItem key={empresa.id} value={empresa.id}>
                    {empresa.nombre}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth required margin="normal">
              <InputLabel>Rol</InputLabel>
              <Select name="id_rol" value={formData.id_rol} onChange={handleChange}>
                {roles.map((rol) => (
                  <MenuItem key={rol.id} value={rol.id}>
                    {rol.nombre}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* <Typography variant="h6" sx={{ marginTop: 2 }}>
              Firma
            </Typography>
            <SignatureCanvas
              ref={signatureRef}
              penColor="black"
              canvasProps={{ width: 500, height: 200, className: "signature-canvas" }}
            />
            <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: 2 }}>
              <Button variant="contained" color="secondary" onClick={handleClearSignature} sx={{ backgroundColor: "#189CD8", color: "white", '&:hover': { backgroundColor: "#54b1db" } }}>
                Limpiar Firma
              </Button>
              <Button variant="contained" onClick={handleSaveSignature} sx={{ backgroundColor: "#2C6595", color: "white", '&:hover': { backgroundColor: "#014377" } }}>
                Guardar Firma
              </Button>
            </Box> */}

            {editMode && formData.firma && (
              <Box sx={{ marginBottom: 2 }}>
                <Typography variant="body2" sx={{ marginBottom: 1 }}>Firma actual:</Typography>
                <img src={formData.firma} alt="Firma existente" style={{ border: "1px solid #ccc", maxWidth: "100%", height: "auto" }} />
                <Typography variant="body2" sx={{ fontStyle: "italic", marginTop: 1 }}>
                  Si deseas actualizar la firma, dibuja en el cuadro de abajo y guarda.
                </Typography>
              </Box>
            )}

            <SignatureCanvas
              ref={signatureRef}
              penColor="black"
              canvasProps={{ width: 500, height: 200, className: "signature-canvas" }}
            />
            <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: 2 }}>
              <Button variant="contained" color="secondary" onClick={handleClearSignature} sx={{ backgroundColor: "#189CD8", color: "white", '&:hover': { backgroundColor: "#54b1db" } }}>
                Limpiar Firma
              </Button>
              <Button variant="contained" onClick={handleSaveSignature} sx={{ backgroundColor: "#2C6595", color: "white", '&:hover': { backgroundColor: "#014377" } }}>
                Guardar Firma
              </Button>
            </Box>
            <Box sx={{ marginTop: 2 }}>
              <Button type="submit" variant="contained" fullWidth sx={{ backgroundColor: "#01579b", color: "white", '&:hover': { backgroundColor: "#014377" } }}>
                {editMode ? "Actualizar Contacto" : "Guardar Contacto"}
              </Button>
            </Box>
          </form>
        </Box>
      )}

      <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="md">
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1A3E5D", marginBottom: 2 }}>
            Información del Contacto
          </Typography>
          <IconButton onClick={handleCloseDialog} color="primary">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          {selectedContact && (
            <Box sx={{ padding: 3 }}>
              <Card sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, maxWidth: 600, margin: '0 auto', boxShadow: 3 }}>
                {/* Perfil del Contacto */}
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4} sx={{ backgroundColor: '#2c6595', color: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 2 }}>
                    <Avatar
                      alt={selectedContact.nombre}
                      src={selectedContact.avatar || "https://img.icons8.com/bubbles/100/000000/user.png"}
                      sx={{ width: 120, height: 120 }}
                    />
                    <Typography variant="h6" sx={{ marginTop: 2, fontWeight: 'bold' }}>
                      {selectedContact.nombre} {selectedContact.apellido}
                    </Typography>
                    <Typography>{selectedContact.rol}</Typography>
                  </Grid>

                  {/* Información del Contacto */}
                  <Grid item xs={12} sm={4} >
                    <CardContent sx={{ padding: 3 }}>
                      <Typography variant="h6" sx={{ fontWeight: 'bold', borderBottom: '1px solid #ddd', paddingBottom: 1 }}>
                        Información
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>Correo:</Typography>
                          <Typography variant="body2" color="textSecondary">{selectedContact.correo}</Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>Teléfono:</Typography>
                          <Typography variant="body2" color="textSecondary">{selectedContact.telefono}</Typography>
                        </Grid>
                      </Grid>
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>Empresa:</Typography>
                          <Typography variant="body2" color="textSecondary"> {empresas.find((empresa) => empresa.id === selectedContact.id_empresa)?.nombre}</Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>Rol:</Typography>
                          <Typography variant="body2" color="textSecondary">{roles.find((rol) => rol.id === selectedContact.id_rol)?.nombre}</Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Grid>
                </Grid>
              </Card>

              {/* Firma debajo de la información */}
              {selectedContact.firma && (
                <Box sx={{ marginTop: 3 }}>
                  <Card sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, maxWidth: 600, margin: '0 auto', boxShadow: 3 }}>
                    <CardContent sx={{ padding: 3 }}>
                      <Typography variant="h6" sx={{ fontWeight: 'bold', borderBottom: '1px solid #ddd', paddingBottom: 1 }}>
                        Firma
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <img
                            src={selectedContact.firma}
                            alt="Firma del contacto"
                            style={{ maxWidth: "100%", height: "auto", marginTop: 1 }}
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Box>
              )}
            </Box>
          )}
        </DialogContent>

        {/* <DialogActions>
        <Button onClick={handleCloseDialog} color="primary">
          Cerrar
        </Button>
      </DialogActions> */}
      </Dialog>

      {/* Alerta */}
      <Snackbar open={alertOpen} autoHideDuration={6000} onClose={() => setAlertOpen(false)} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={() => setAlertOpen(false)} severity={alertSeverity} sx={{ width: "100%" }}>
          {alertMessage}
        </Alert>
      </Snackbar>

      {/* Modal de Confirmación de Eliminación */}
      <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
        <DialogTitle>Confirmación</DialogTitle>
        <DialogContent>
          <Typography>¿Estás seguro de eliminar este contacto?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancelar
          </Button>
          <Button onClick={() => handleDelete(currentContactId)} color="secondary">
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default RegistroContacto;
